module.exports = __webpack_public_path__ + "img/upper-reserved.07e77b23.svg";